import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Tooltip from '@mui/material/Tooltip';

import { alpha } from '@mui/material/styles';

const styles = theme => ({

    link: {
        ...theme.style.link,
        // Pas d'outline de focus : la sélection est déjà marquée par le fond coloré + le liseré gauche.
        '&:focus': {
            outline: 'none'
        }
    },

    selected: {
        color: theme.palette.selected
    },

    listItemIcon: {
        margin: 0,
        marginLeft: 4,
        padding: 0
    },

    listItem: {
        paddingRight: 8,
        paddingLeft: 8,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },

    listItemSelected: {
        boxShadow: 'inset 4px 0 0 ' + theme.palette.selected,
        backgroundColor: alpha(theme.palette.selected, 0.08),
        '&:hover': {
            backgroundColor: alpha(theme.palette.selected, 0.12)
        }
    }
});

const ReclamationsDrawerListItem = ({ classes, selected, expanded, onClick, title, icon, href }) => {


    let listItem = (
        <React.Fragment>
            {selected && (
                <Helmet>
                    <title>{title}</title>
                </Helmet>
            )}

            <Tooltip title={title} disableFocusListener disableTouchListener disableHoverListener={expanded} placement="right">
                <ListItem button onClick={onClick} className={classNames(classes.listItem, selected && classes.listItemSelected)}>
                    <ListItemIcon className={classNames(classes.listItemIcon, selected && classes.selected)}>
                        {icon}
                    </ListItemIcon>

                    {expanded && (
                        <ListItemText
                            primary={title}
                            primaryTypographyProps={selected ? { className: classes.selected } : {}}
                        />
                    )}
                </ListItem>
            </Tooltip>
        </React.Fragment>
    );


    return (
        <Link to={href} className={classes.link}>
            {listItem}
        </Link>
    );

};

ReclamationsDrawerListItem.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    selected: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,

    title: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired
};

export default withStyles(styles, { withTheme: true })(ReclamationsDrawerListItem);